module.exports = __webpack_public_path__ + "assets/setting.3768c78d.svg";